class CFSession {
    get UserId() {
        return cf.session.userId;
    }

    get TentantId() {
        return cf.session.tenantId;
    }

    get ImpersonatorUserId() {
        return cf.session.impersonatorUserId;
    }

    get ImpersonatorTenantId() {
        return cf.session.impersonatorTenantId;
    }

    get MultiTenancySide() {
        return cf.session.multiTenancySide;
    }
}
export default new CFSession();
